import { Menu as JoyMenu, MenuItem, menuItemClasses, styled, Typography } from '@mui/joy';

export const Menu = styled(JoyMenu)({
  zIndex: 'var(--joy-zIndex-modal)',
  minWidth: 200,
});

export const LabelMenuItem = styled(MenuItem)({
  justifyContent: 'space-between',

  [`&:not(.${menuItemClasses.selected}, [aria-selected="true"]):hover`]: {
    backgroundColor: 'transparent',
  },
});

export const Label = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.neutral[500],
  fontWeight: 600,
}));
